import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-nav-item-accessory, [glxyNavItemAccessory]',
  standalone: false,
})
export class GalaxyNavItemAccessoryDirective {
  @HostBinding('class') class = 'glxy-nav-item-accessory';
}
